var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":_vm.formaPago.nombre,"subtitle":"Forma de pago","back-to":"/formasPago"}}),_c('formulario-forma-pago',{attrs:{"forma-pago":_vm.formaPago},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }